import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { NavigationExtras, Router } from '@angular/router';
import {Location, PlatformLocation} from '@angular/common';
import { CreditUnionService, CreditUnionSummaryOutput, CreditUnoinUserService } from 'openapi';
import { AppModuleType } from '@shared/AppEnums';
import { SharedDataService } from '@app/_helpers/shareddata.service';
import { Platform } from '@ionic/angular';
import { Globals } from '@app/globals';
import { StringUtils } from '@shared/utils/StringUtils';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.less']
})
export class FooterComponent implements OnInit {

  activeClass:boolean = false;
  pageUrl: string;
  tenantId:any;
  displayMenuName:string= "YourGroups";
  creditUnion:CreditUnionSummaryOutput;
  appModuleType = AppModuleType;

  constructor(private _router: Router,private _creditUnoinUserService: CreditUnoinUserService, private _location: Location,
    public sharedDataService: SharedDataService, private platform: Platform
    , private location: PlatformLocation,
    private _cdr: ChangeDetectorRef,
    public globals: Globals) { 

    this._router.events.subscribe((val) => {
      if(this._location.path() != ''){
        this._cdr.detectChanges();
        this.pageUrl = _location.path();
        // console.log(this.pageUrl)
        if(this.pageUrl === '/credit-union-list' || this.pageUrl === '/credit-union' ){
          this.activeClass = true;
        }else{
          this.activeClass = false;
        }
      } 
    });

   }

  ngOnInit(): void {

    this.tenantId = window.localStorage.getItem("Abp.TenantId");
    if(this.tenantId != "null")
    {
      this._creditUnoinUserService.apiCrediUnionGet().subscribe((res:CreditUnionSummaryOutput) => {
        this.creditUnion = res;
        if(this.creditUnion.appModuleType == this.appModuleType.Saccos)
          this.displayMenuName = 'SACCOS';
        if(this.creditUnion.appModuleType == this.appModuleType.Merrygoround)
          this.displayMenuName = 'PesaChama';
        if(this.creditUnion.appModuleType == this.appModuleType.Microfinance)
          this.displayMenuName = 'Microfinance';
        this.sharedDataService._selectedModuleName = this.displayMenuName;
      });
    }
    else
    this.displayMenuName = "YourGroups" 
 
}
tabCLick(url)
{
  this.globals.bottomTabProfile = 'Profile';
  this._cdr.detectChanges();
  this._router.navigate([url]);
}
  cuClicked()
  {
    let tenantId = window.localStorage.getItem("Abp.TenantId");
    if(StringUtils.isMobilePlatform(this.platform)){
      this._cdr.detectChanges();
      console.log('mobile android');
      // const navigationExtras: NavigationExtras = {
      //   queryParams: {
      //     clearHistory: '1'
      //   },
      // };
      if(StringUtils.isMobilePlatform(this.platform) && this.platform.is('android')){
       window.localStorage.setItem('clearHistory', '1');
      }
      this._router.navigate(['credit-union-list']);

    }
    else {
      if (!(tenantId == 'null')) {
        this._router.navigate(['credit-union']);
      }
      else {
        this._router.navigate(['credit-union-list']);
         
      }
    }
  }
}
